import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AuthStateProps } from "../../models/auth";
import { User } from "../../models/user";

const initialState: AuthStateProps = {
  user: null,
  institutionId: null,
  planId: null,
  owner: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    saveInstitution: (
      state,
      actions: PayloadAction<{
        institutionId: string;
        planId: string | null;
        owner: boolean;
      }>
    ) => {
      const { payload } = actions;
      if (state.user) {
        state.institutionId = payload.institutionId;
        state.planId = payload.planId;
        state.owner = payload.owner;
      }
    },
    signIn: (state, actions: PayloadAction<User>) => {
      const { payload } = actions;
      state.user = payload;
    },
    signOut: (state) => {
      state.user = null;
      state.institutionId = null;
      state.planId = null;
      state.owner = false;
    },
  },
});

export const { actions } = authSlice;
export default authSlice.reducer;
